<div class="file-preview-sidebar">
  <div class="header">
    <h2>File Details</h2>
    <geaui-icon-v3
      [file]="'16px_close'"
      [color]="'black'"
      [clickable]="true"
      (click)="closeSidebar()"
      style="cursor: pointer"></geaui-icon-v3>
  </div>

  <div class="content flex flex-column p-4 gap-4">
    @if (asset) {
      <div class="preview-container flex justify-content-center">
        <app-file-preview-container [asset]="asset"></app-file-preview-container>
      </div>

      <div class="details-section flex flex-column">
        <div class="detail-item">
          <label class="gea-font-heading-14">File Name</label>
          <p class="file-name gea-font-body-16">{{ asset.fileName }}</p>
        </div>

        <div class="detail-item">
          <label class="gea-font-heading-14">Specifications</label>
          <p class="specifications gea-font-body-16">{{ getFileType() }} · {{ getFileSize() }}</p>
        </div>

        @if (asset.isUserOverride) {
          <div class="detail-item">
            <label class="gea-font-heading-14">Status</label>
            <div class="status-badge edited gea-font-body-16">
              <geaui-icon-v3 [file]="'16px_edit'" [color]="'#856404'"></geaui-icon-v3>
              <span>Edited</span>
            </div>
          </div>
        }

        <div class="detail-item">
          <label class="gea-font-heading-14">Path</label>
          <p class="path gea-font-body-16">{{ asset.path }}</p>
        </div>
      </div>
      @if (asset.isUserOverride) {
        <div>
          <geaui-button-v3 [preIcon]="'reset-2'" [flex]="true" [disabled]="!canMutate" (click)="onUndoChanges()">
            Undo changes
          </geaui-button-v3>
        </div>
      }
      <div class="file-button-options">
        <geaui-button-v3 [inverted]="true" [disabled]="!canMutate || !canReplace" (click)="onReplace()" type="tertiary"
          >Replace</geaui-button-v3
        >
        <geaui-button-v3
          [inverted]="true"
          [disabled]="!canMutate || !allowUpload || !canReplace"
          (click)="onRename()"
          type="tertiary"
          >Rename</geaui-button-v3
        >
        <geaui-button-v3 [inverted]="true" (click)="onDownload()" type="tertiary">Download</geaui-button-v3>
        <geaui-button-v3 [inverted]="true" type="tertiary">Version History</geaui-button-v3>
        <geaui-button-v3
          class="red-color"
          [inverted]="true"
          [disabled]="!canMutate || !allowUpload || !canReplace"
          (click)="onDelete()"
          type="tertiary"
          >Delete</geaui-button-v3
        >
      </div>
    }
  </div>
</div>
